import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let HoverSurfaceActionsOption: LazyOption = createLazyOption(
    {
        key: 'hoverSurfaceActions',
        titleStringKey: 'optionTitle_hoverSurfaceActions',
        searchTermsStringKey: 'optionTitle_hoverSurfaceActions',
        isHidden: () => !isFeatureEnabled('tri-customHoverActions'),
        allowedOptionKeys: ['MailQuickActions'],
    },
    lazyFullModule,
    m => m.HoverFullSettings
);
export default HoverSurfaceActionsOption;
